/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 05.06.13, 13:42
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { GGSTextFieldSignal } from "./GGSTextFieldSignal";

import Event = createjs.Event;

export class ChangeSignal extends GGSTextFieldSignal {
    constructor() {
        super();
        this.mappedEventType = Event.CHANGE;
    }

    public dispatchTyped(event: Event): void {
        super.dispatch(event);
    }
}
